module.exports = __webpack_public_path__ + "static/media/products_services7.70423980.jpg";